import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetNotificationPreferenceRequest } from '@cash-web/shared-util-protos/squareup/franklin/SetNotificationPreferenceRequestProto.pb'
import { SetNotificationPreferenceResponse } from '@cash-web/shared-util-protos/squareup/franklin/SetNotificationPreferenceResponseProto.pb'

export const setNotificationPreference = (request: SetNotificationPreferenceRequest, options?: CashRequestOptions) =>
  post<SetNotificationPreferenceRequest, SetNotificationPreferenceResponse>(
    '/2.0/cash/set-notification-preference',
    request,
    { ...options, rejectOnError: true }
  )
